function Variations() {
}

Variations.fn = {
    init: function () {
        Variations.fn.initClassification.call(this);
    },

    initClassification: function () {
        const numberFormat = new Intl.NumberFormat('vi-VN', {
            style: 'currency',
            currency: 'VND',
        });

        //check out of stock
        var status_disabled = true;
        $('body .single-product-list-variations ul li:nth-child(1) ul.sub li').each(function () {
            if (!$(this).hasClass('disabled')) {
                status_disabled = false;
            }
        });
        if (status_disabled) {
            $('body .single-product-list-variations ul li ul.sub li').addClass('disabled');
        }

        $('body .single-product-list-variations ul li:nth-child(1) ul.sub li').on('click', function () {
            var val = $(this).attr('data-value');
            var data_attributes = $('body .data_attributes').val();
            if (data_attributes !== '') {
                data_attributes = JSON.parse(data_attributes);
                data_attributes.attribute.forEach(function (item) {
                    if (val.trim() === item.parent.trim()) {
                        $('body .single-product-list-variations ul li:nth-child(2) ul.sub li').each(function () {
                            if (item.value.trim() === $(this).attr('data-value')) {
                                if (item.qty_value.trim() === '' || parseInt(item.qty_value.trim()) <= 0) {
                                    $(this).addClass('disabled').removeClass('active');
                                } else {
                                    $(this).removeClass('disabled');
                                }
                            }
                        });
                    }
                });
            }
            $('body .list-product-thumb .gallery-item[data-name="' + val + '"]').click().trigger('click');

            if ($(this).data('clicked')) return;
            $(this).data('clicked', true);

            var $li = $('body .single-product-list-variations ul li:nth-child(2) ul.sub li').not('.disabled').first();
            if ($li.length) {
                $li.trigger('click');
            }
            $(this).data('clicked', false);
        });

        $('body .single-product-list-variations ul li ul.sub li').on('click', function () {
            if (!$(this).hasClass('disabled')) {
                $(this).parent().find('li').removeClass('active');
                $(this).addClass('active');
            }


            var slt_attr = [];
            $('body .single-product-list-variations ul li').each(function () {
                $(this).find('ul.sub li').each(function () {
                    if (!$(this).hasClass('disabled')) {
                        if ($(this).hasClass('active')) {
                            slt_attr.push({
                                title: $(this).parent().siblings('span').text(),
                                value: $(this).attr('data-value'),
                                sku: $('body .single-product-list-variations').attr('data-sku')
                            });
                        }
                    }
                });
            });
            // $('.select_attr').val(JSON.stringify(slt_attr));

            var attributes;
            var count_li = $('body .single-product-list-variations ul li.parent').length;
            if ($('.data_attributes').length > 0) {
                attributes = JSON.parse($('.data_attributes').val());

                if (count_li === 1) {
                    attributes.attribute.forEach(function (item) {
                        var value = item.value;
                        var price_value = item.price_value;
                        var sku_value = item.sku_value;

                        if (value === slt_attr[0].value) {
                            if (price_value !== '') {
                                var totalPrice = price_value * parseInt($('body .quantity input.qty').val());
                                $('body .single-product-list-variations').attr('data-sku', sku_value);

                                if (price_value == "" || price_value == 0) {
                                    $('body .product-info .is-sale .product-sale-price').html("Liên hệ");
                                    $('.order-product').removeClass("d-flex").hide();
                                } else {
                                    $('body .product-info .is-sale .product-sale-price').html(numberFormat.format(totalPrice));
                                    $('.order-product').addClass("d-flex").show();
                                }

                                $('body .product-info .is-sale .product-sale-price').attr('data-price', price_value);
                                $('body .product-info .is-sale .product-normal-price').hide();
                            } else {
                                $('.product-info').hide();
                            }
                        }
                    });
                } else {
                    attributes.attribute.forEach(function (item) {
                        var value = item.value;
                        var parent = item.parent;
                        var price_value = item.price_value;
                        var sku_value = item.sku_value;

                        if (value && parent === slt_attr[0].value && value === slt_attr[1].value) {
                            if (price_value !== '') {
                                var totalPrice = price_value * parseInt($('body .quantity input.qty').val());
                                $('body .single-product-list-variations').attr('data-sku', sku_value);

                                if (price_value == "" || price_value == 0) {
                                    $('body .product-info .is-sale .product-sale-price').html("Liên hệ");
                                    $('.order-product').removeClass("d-flex").hide();
                                } else {
                                    $('body .product-info .is-sale .product-sale-price').html(numberFormat.format(totalPrice));
                                    $('.order-product').addClass("d-flex").show();
                                }

                                $('body .product-info .is-sale .product-sale-price').attr('data-price', price_value);
                                $('body .product-info .is-sale .product-normal-price').hide();
                            } else {
                                $('.product-info').hide();
                            }
                        }
                    });
                }
            }

            var attrPush = [];
            $('body .single-product-list-variations ul li').each(function () {
                $(this).find('ul.sub li').each(function () {
                    if (!$(this).hasClass('disabled')) {
                        if ($(this).hasClass('active')) {
                            attrPush.push({
                                title: $(this).parent().siblings('span').text(),
                                value: $(this).attr('data-value'),
                                sku: $('body .single-product-list-variations').attr('data-sku'),
                                image: $(this).attr('data-image')
                            });
                        }
                    }
                });
            });
            $('.select_attr').val(JSON.stringify(attrPush));
        });

        $('body .quantity input.qty').on('change', function () {
            if ($('.data_attributes').length > 0) {
                var price = parseInt($('body .product-info .is-sale .product-sale-price').attr('data-price'));
                var totalPrice = price * parseInt($(this).val());
                
                if (price == "" || price == 0) {
                    $('body .product-info .is-sale .product-sale-price').html("Liên hệ");
                    $('.order-product').removeClass("d-flex").hide();
                } else {
                    $('body .product-info .is-sale .product-sale-price').html(numberFormat.format(totalPrice));
                    $('.order-product').addClass("d-flex").show();
                }

                return false;
            }
        });

        $('.product-info').show();

        setTimeout(function () {
            $('body .single-product-list-variations ul li.parent ul.sub li').not('.disabled').first().click().trigger('click');
        }, 100);

        //check disable attributes
        var class_not_disable = $('body .single-product-list-variations ul li.parent:nth-child(1) ul.sub li').length;
        var class_disable = 0;
        $('body .single-product-list-variations ul li.parent:nth-child(1) ul.sub li').each(function () {
            if ($(this).hasClass('disabled')) {
                class_disable++;
            }
        });
        // if (class_not_disable === class_disable) {
        //     $('body .single-product-list-variations').hide();
        // }
    },

    rule: function () {
        $(document).ready(function () {
            Variations.fn.init.call(this);
        });
    },
};

Variations.fn.rule();
